import { ChangeDetectorRef, Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[data-test-id]',
  standalone: true
})
export class DataTestIdDirective {
  readonly elementName = input<string | null>(null, { alias: 'data-test-id' });

  private el = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const name = this.elementName();
      if (!name) {
        this.el.nativeElement.removeAttribute('data-test-id');
        return;
      }
      const componentName =
        (this.cdr as unknown as { context?: { constructor?: { name?: string } } })?.context?.constructor?.name ?? '';
      this.el.nativeElement.setAttribute('data-test-id', formatId(componentName, name));
    });
  }
}

function formatId(comp: string, action: string): string {
  const cleanComp = comp.replace(/Component$/i, '');
  return `${cleanComp}-${action}`
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
